import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { z } from 'zod';
import { calculatorSchema } from './calculatorSchema';
import {
  BANK_PENALTY_IF_ANY,
  COMPLETION_PERIOD,
  EXERCISE_PERIOD,
  GST_PERCENT,
  LEGAL_FEE,
  SERVICE_COMMISSION_PERCENT,
  SSD,
  TEMPORARY_EXTENSION_OF_STAY,
  OPTION_FEE,
  OPTION_EXERCISE_FEE,
} from '@/constants/private-resale/sales-proceeds';

export const initialState = {
  formField: {
    sellingPrice: '',
    outstandingLoan: '',
    optionFee: OPTION_FEE.DEFAULT.toString(),
    optionExerciseFee: OPTION_EXERCISE_FEE.DEFAULT.toString(),
    ssd: SSD.DEFAULT.toString(),
    legalFees: LEGAL_FEE.DEFAULT.toString(),
    bankPenaltyIfAny: BANK_PENALTY_IF_ANY.LIST[1].value,
    bankPenalty: '0',
    serviceCommissionPercent: SERVICE_COMMISSION_PERCENT.toString(),
    gstPercent: GST_PERCENT.toString(),
    others: '',
    otpDate: new Date().toString(),
    exercisePeriod: EXERCISE_PERIOD.DEFAULT,
    completionPeriod: COMPLETION_PERIOD.DEFAULT,
    temporaryExtensionOfStay: TEMPORARY_EXTENSION_OF_STAY.DEFAULT.toString(),
    profiles: [
      {
        name: 'Profile A',
        cpfUsedForHousing: '',
        cpfAccruedInterest: '',
      },
      {
        name: 'Profile B',
        cpfUsedForHousing: '',
        cpfAccruedInterest: '',
      },
    ],
  },
  loading: true,
};

export const salesProceedSlice = createSlice({
  name: 'salesProceed',
  initialState,
  reducers: {
    updateFormField: (state, action: PayloadAction<z.infer<typeof calculatorSchema>>) => {
      state.formField = action.payload;
    },
  },
  extraReducers: () => {},
});

export const { updateFormField } = salesProceedSlice.actions;

export default salesProceedSlice.reducer;
